"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _utils = require("../../style/utils");

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _heading = require("./heading.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

let Heading = /*#__PURE__*/function (_React$Component) {
  _inherits(Heading, _React$Component);

  var _super = _createSuper(Heading);

  function Heading() {
    _classCallCheck(this, Heading);

    return _super.apply(this, arguments);
  }

  _createClass(Heading, [{
    key: "help",
    get:
    /**
     * Returns the help component.
     *
     * @method help
     * @return {Object} JSX
     */
    function () {
      if (!this.props.help && !this.props.helpLink) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_heading.StyledHeaderHelp, {
        "data-element": "help",
        tooltipPosition: "right",
        href: this.props.helpLink
      }, this.props.help);
    }
    /**
     * Returns the back button.
     *
     * @method back
     * @return {Object} JSX
     */

  }, {
    key: "back",
    get: function () {
      if (!this.props.backLink) {
        return null;
      }

      let props;

      if (typeof this.props.backLink === "string") {
        props = {
          href: this.props.backLink
        };
      } else {
        props = {
          onClick: this.props.backLink
        };
      }

      return /*#__PURE__*/_react.default.createElement(_heading.StyledHeadingBackButton // this event allows an element to be focusable on click event on IE
      , _extends({
        onMouseDown: e => e.currentTarget.focus(),
        "data-element": "back"
      }, props), /*#__PURE__*/_react.default.createElement(_heading.StyledHeadingIcon, {
        type: "chevron_left",
        divider: this.props.divider
      }));
    }
    /**
     * Returns the subheader.
     *
     * @method subheader
     * @return {Object} JSX
     */

  }, {
    key: "subheader",
    get: function () {
      if (!this.props.subheader) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_heading.StyledSubHeader, {
        "data-element": "subtitle",
        id: this.props.subtitleId,
        hasBackLink: !!this.props.backLink,
        hasSeparator: this.props.separator
      }, this.props.subheader);
    }
    /**
     * Returns the separator if enabled and needed.
     *
     * @method separator
     * @return {Object} JSX
     */

  }, {
    key: "separator",
    get: function () {
      return this.props.separator ? /*#__PURE__*/_react.default.createElement(_heading.StyledSeparator, null) : null;
    }
    /**
     * Returns the separator if enabled and needed.
     *
     * @method divider
     * @return {Object} JSX
     */

  }, {
    key: "divider",
    get: function () {
      return this.props.divider ? /*#__PURE__*/_react.default.createElement(_heading.StyledDivider, {
        "data-element": "divider"
      }) : null;
    }
    /**
     * Returns pills if provided
     *
     * @method pills
     * @return {Object} JSX
     */

  }, {
    key: "pills",
    get: function () {
      return this.props.pills ? /*#__PURE__*/_react.default.createElement(_heading.StyledHeadingPills, {
        "data-element": "pills"
      }, this.props.pills) : null;
    }
    /**
     * @method render
     * @return {Object} JSX
     */

  }, {
    key: "render",
    value: function render() {
      if (!this.props.title) {
        return null;
      }

      const marginProps = (0, _utils.filterStyledSystemMarginProps)(this.props);
      return /*#__PURE__*/_react.default.createElement(_heading.StyledHeading, _extends({}, (0, _tags.default)("heading", this.props), marginProps), /*#__PURE__*/_react.default.createElement(_heading.StyledHeader, {
        "data-element": "header-container",
        divider: this.props.divider,
        subheader: this.props.subheader,
        hasBackLink: !!this.props.backLink
      }, this.back, /*#__PURE__*/_react.default.createElement(_heading.StyledHeaderContent, null, /*#__PURE__*/_react.default.createElement(_heading.StyledHeadingTitle, {
        withMargin: this.props.pills || this.props.help,
        variant: "h1",
        "data-element": "title",
        id: this.props.titleId
      }, this.props.title), this.help, this.pills), this.separator, this.subheader), this.divider, this.props.children);
    }
  }]);

  return Heading;
}(_react.default.Component);

_defineProperty(Heading, "propTypes", { ...marginPropTypes,

  /**
   * Children elements
   */
  children: _propTypes.default.node,

  /**
   * Defines the title for the heading.
   */
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * Defines the title id for the heading.
   */
  titleId: _propTypes.default.string,

  /**
   * Defines the subheader for the heading.
   */
  subheader: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),

  /**
   * Defines the subtitle id for the heading.
   */
  subtitleId: _propTypes.default.string,

  /**
   * Defines the help text for the heading.
   */
  help: _propTypes.default.string,

  /**
   * Defines the help link for the heading.
   */
  helpLink: _propTypes.default.string,

  /**
   * Defines the a href for the back link.
   */
  backLink: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),

  /**
   * Adds a divider below the heading and the content.
   */
  divider: _propTypes.default.bool,

  /**
   * Adds a separator between the title and the subheader.
   */
  separator: _propTypes.default.bool,

  /**
   * Pills that will be added after the title.
   */
  pills: _propTypes.default.node
});

_defineProperty(Heading, "defaultProps", {
  divider: true,
  separator: false
});

var _default = Heading;
exports.default = _default;